export default __webpack_public_path__ + "static/media/pricelocq-logo.c146bd37.svg";